module.exports = __webpack_public_path__ + "img/people_big1.e68b621c.png";